export default class ScrollUtils {
  static getCurrentYPosition() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  static getElementYPosition(element) {
    let y = element.offsetTop;
    let node = element;
    while (node.offsetParent && node.offsetParent !== document.body) {
      node = node.offsetParent;
      y += node.offsetTop;
    }
    return y;
  }

  static getWindowWidth() {
    return window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;
  }

  static scroll(currentPos, targetPos, frame = 0) {
    // eslint-disable-next-line no-param-reassign
    frame += 1;
    if (frame > 30) return;
    // eslint-disable-next-line no-mixed-operators
    const delta = currentPos + (targetPos - currentPos) / 30 * frame;
    // eslint-disable-next-line no-multi-assign
    document.documentElement.scrollTop = document.body.scrollTop = delta;
    setTimeout(() => {
      this.scroll(currentPos, targetPos, frame);
    }, 20);
  }
}
